module.exports = __webpack_public_path__ + "static/media/location-maps-letter-i-arrow-serr1.7aea36a4.png";